import { FieldDto } from "@se/platform/forms/dtos/out/formFields/fieldDto";
import { fromEvent } from "rxjs";
import { pluck } from "rxjs/operators";
import { FormFieldComponent } from "../formFieldComponent";
import { Form } from "../form";
import { IMessagingService } from "../../services";

class CheckboxListComponent extends FormFieldComponent {

    private inputEls: HTMLInputElement[];

    constructor(protected fieldEl: HTMLElement, messagingService: IMessagingService, protected form: Form) {
        super(fieldEl, messagingService, form);


        this.inputEls = Array.from(fieldEl.querySelectorAll<HTMLInputElement>(".js-checkbox"));

        this.inputEls.forEach(inputEl => {

            // listen for any of the checkbox fields changing and update its response value
            const onCheckboxClicked$ = fromEvent(inputEl, "change").pipe(
                pluck("target", "value")
            );
            
            onCheckboxClicked$.subscribe(_ => {
                const selectedOptions = this.inputEls.filter(a => a.checked).map(checkbox => checkbox.value);
                super.setResponseValue(selectedOptions);
            });
        });
    }
            
    // update the value of this field in the DOM.
    protected setDisplayValue(value: string[]) {

        if(value) {
            this.inputEls.forEach(el => el.checked = value.indexOf(el.value) > -1);
        }
    }
        
    public setFocus() {
        this.inputEls[0].focus();
    }
};

export { CheckboxListComponent  };